const termsOfService = {
  title: "Общи Условия",
  sections: [
    {
      heading: "1. Съгласие с Условията",
      paragraphs: [
        'С достъпа и използването на услугите на Elite Dental Solutions ("ние," "нашият," или "нас"), вие се съгласявате да бъдете обвързани с тези Общи условия. Ако не сте съгласни с тези условия, моля, не използвайте нашите услуги.',
      ],
    },
    {
      heading: "2. Описание на Услугите",
      paragraphs: [
        "Ние предоставяме дентални и орални здравни услуги, включително, но не само:",
      ],
      bullets: [
        "Дентални прегледи и консултации",
        "Превантивна дентална грижа",
        "Възстановителни лечения",
        "Козметични дентални процедури",
        "Орална хирургия",
        "Спешна дентална помощ",
      ],
    },
    {
      heading: "3. Часове и Отказване",
      paragraphs: [
        "Изискваме 24-часово предизвестие за отказване на час. Късно отказване или пропуснати часове може да доведат до такса. Запазваме си правото да изискваме депозит за определени процедури или лечения.",
      ],
    },
    {
      heading: "4. Условия за Плащане",
      paragraphs: [
        "Плащането се изисква в момента на услугата, освен ако не са договорени други условия. Приемаме различни методи на плащане, включително в брой, кредитни карти и одобрени планове за плащане. Претенциите към застраховки са отговорност на пациента.",
      ],
    },
    {
      heading: "5. Медицинска Информация",
      paragraphs: [
        "Съгласявате се да предоставите точна и пълна медицинска история. Непредоставянето на съответната медицинска информация може да повлияе на резултатите от лечението и може да бъде опасно за вашето здраве.",
      ],
    },
    {
      heading: "6. Решения за Лечение",
      paragraphs: [
        "Докато ние предоставяме професионални препоръки, вие имате правото да вземате информирани решения относно вашето лечение. Ние ще обясним възможностите за лечение, рисковете и ползите, за да ви помогнем да вземете тези решения.",
      ],
    },
    {
      heading: "7. Използване на Уебсайта",
      paragraphs: [
        "Нашият уебсайт е само за информационни цели. Въпреки че се стремим да предоставяме точна информация, тя не трябва да се счита за медицински съвет. Винаги се консултирайте с дентален специалист за конкретен медицински съвет.",
      ],
    },
    {
      heading: "8. Ограничение на Отговорността",
      paragraphs: [
        "Стремим се да предоставяме дентална грижа с най-високо качество, но не можем да гарантираме конкретни резултати. Не носим отговорност за никакви непреки, последващи или случайни щети, свързани с нашите услуги.",
      ],
    },
    {
      heading: "9. Промени в Условията",
      paragraphs: [
        "Запазваме си правото да променяме тези условия по всяко време. Промените влизат в сила веднага след публикуването им на нашия уебсайт. Продължаващото използване на нашите услуги представлява приемане на модифицираните условия.",
        "Последна актуализация:",
      ],
      lastUpdatedLocale: "bg-BG",
    },
  ],
};

export default termsOfService;

